import { LineItem } from 'shopify-buy';
import get from 'lodash/get';
import debug from 'debug';
const d = debug('shopifyHelpers');

export const shopifyExtractId = (entityId: string): number | undefined => {
  try {
    // @ts-ignore
    const decoded: string = atob(entityId);
    return Number(decoded.substring(decoded.lastIndexOf('/') + 1));
  } catch (err) {
    d('decodeError', entityId);
    return undefined;
  }
};

export const shopifyLineItemToEcommerceLineItem = (lineItem: LineItem) => {
  return {
    item_id: shopifyExtractId(get(lineItem, 'variant.product.id')), // Switch to product.id
    item_name: get(lineItem, 'title'), // Leave as product.title
    item_variant: get(lineItem, 'variant.sku'), // variant.sku
    price: Number(get(lineItem, 'variant.priceV2.amount', 99999)),
    currency: get(lineItem, 'variant.priceV2.currencyCode', 'AUD'),
    quantity: lineItem.quantity,
  };
};

export const shopifyAdminProductLink = (productId: number) => {
  if (process.env['REACT_APP_SHOPIFY_ADMIN']) return `https://${process.env['REACT_APP_SHOPIFY_ADMIN']}/admin/products/${productId}`;
  return `https://tcn-card-dot-gift-dev.myshopify.com/admin/products/${productId}`;
};
